"use client";
import useFilters from "@/app/lib/features/filters/filters.hook";
import SpecialFiltersSwiper from "../filters/SpecialFiltersSwiper";
import ProductFilterSystem from "../filters/ProductFilterSystem";
import { Button } from "@/app/components/shadcn/button";
import { SlidersHorizontal } from "lucide-react";

interface ProductsHeaderProps {
  title?: string | null;
  productCount?: number;
  onOpenFilter?: () => void;
  disableMinimumFilter?: boolean;
}

const ProductsHeader = ({
  title = "",
  productCount,
  onOpenFilter,
  disableMinimumFilter,
}: ProductsHeaderProps) => {
  const { specialFilters, selected, toggleSpecial } =
    useFilters();

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <h1 className="font-medium text-lg">{title}</h1>
        {productCount !== undefined && (
          <p className="text-sm text-muted-foreground">{productCount}+ Ürün</p>
        )}
      </div>

      <div className="flex items-center gap-2">
        {onOpenFilter && (
          <Button
            variant="outline"
            size="sm"
            className="lg:hidden shrink-0 gap-1.5 h-8"
            onClick={onOpenFilter}
          >
            <SlidersHorizontal size={14} />
            Filtrele
          </Button>
        )}
        {specialFilters.length > 0 && (
          <div className="flex-1 min-w-0">
            <SpecialFiltersSwiper
              specialFilters={specialFilters}
              selected={selected}
              toggleSpecial={toggleSpecial}
            />
          </div>
        )}
      </div>

      <ProductFilterSystem disableMinimumFilter={disableMinimumFilter} />
    </div>
  );
};

export default ProductsHeader;
